import { Locales } from "../../strings/Locales.js";
var getSourceTypeLabel = function(sourceType) {
    return Locales.formatOrDefault("SourceIdentity.sourceType.".concat(sourceType, ".label"), {
        defaultTranslation: sourceType
    });
};
export var SourceIdentityHelper = {
    getSourceTypeLabel: getSourceTypeLabel
};

//# sourceMappingURL=SourceIdentityHelper.js.map